import { ChainID } from '@jdiyield/constants'
import { Contract, PriceList, Stake, Token } from '@jdiyield/interfaces'
import BigNumber from 'bignumber.js'
import Web3 from 'web3'

import { calculate } from '../calculate'
import getNodeUrl from '../rpcRandom'
import { findToken, makeBatchRequest } from '../utils'

export const getSyrupPool = async (
  walletAddress: string,
  contract: Contract,
  tokens: Token[],
  priceList: PriceList,
  chainID: ChainID,
  web3Prop: Web3
): Promise<Stake[]> => {
  const { contractAddress, rewardAddress, routerAddress, pendingReward } = contract
  try {
    const web3 = web3Prop || new Web3(getNodeUrl(chainID))
    const { SmartChefInitializable } = await import('@jdiyield/abi')
    const ct = new web3.eth.Contract(SmartChefInitializable as any, contractAddress)

    const [userInfo, _pendingReward, lpAddress] = await makeBatchRequest(web3, [
      ct.methods.userInfo(walletAddress).call,
      ct.methods[pendingReward](walletAddress).call,
      ct.methods.stakedToken().call
    ])

    const rewardInfo = findToken(tokens, rewardAddress)
    const reward = new BigNumber(_pendingReward as string).dividedBy(`1e18`).toNumber()
    const stakeAmount = userInfo['amount']
    const rewardUSD = reward * priceList[rewardAddress]?.usd || 0
    const rewardSymbol = rewardInfo?.symbol ?? '???'

    const balanceInfo = await calculate(
      web3,
      {
        lpAddress,
        pool: 0,
        availableBalanceOf: '0',

        balance: stakeAmount
      },
      routerAddress,
      tokens,
      priceList
    )
    const result: Stake = {
      ...contract,
      ...balanceInfo,
      reward: +reward,
      rewardSymbol,
      rewardUSD
    }
    return [result]
  } catch (e) {
    console.log(contract, e)
    return []
  }
}
